import { __read } from "tslib";
import * as u from '@virtuoso.dev/urx';
import { empty } from './AATree';
import { domIOSystem } from './domIOSystem';
import { propsReadySystem } from './propsReadySystem';
import { scrollToIndexSystem } from './scrollToIndexSystem';
import { sizeSystem } from './sizeSystem';
export function getInitialTopMostItemIndexNumber(location, totalCount) {
    var lastIndex = totalCount - 1;
    var index = typeof location === 'number'
        ? location
        : location.index === 'LAST'
            ? lastIndex
            : location.index;
    return index;
}
export var initialTopMostItemIndexSystem = u.system(function (_a) {
    var _b = __read(_a, 4), _c = _b[0], sizes = _c.sizes, listRefresh = _c.listRefresh, defaultItemSize = _c.defaultItemSize, scrollTop = _b[1].scrollTop, scrollToIndex = _b[2].scrollToIndex, didMount = _b[3].didMount;
    var scrolledToInitialItem = u.statefulStream(true);
    var initialTopMostItemIndex = u.statefulStream(0);
    u.connect(u.pipe(didMount, u.withLatestFrom(initialTopMostItemIndex), 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    u.filter(function (_a) {
        var _b = __read(_a, 2), _ = _b[0], location = _b[1];
        return !!location;
    }), u.mapTo(false)), scrolledToInitialItem);
    u.subscribe(u.pipe(u.combineLatest(listRefresh, didMount), u.withLatestFrom(scrolledToInitialItem, sizes, defaultItemSize), u.filter(function (_a) {
        var _b = __read(_a, 4), _c = __read(_b[0], 2), didMount = _c[1], scrolledToInitialItem = _b[1], sizeTree = _b[2].sizeTree, defaultItemSize = _b[3];
        return (didMount &&
            (!empty(sizeTree) || defaultItemSize !== undefined) &&
            !scrolledToInitialItem);
    }), u.withLatestFrom(initialTopMostItemIndex)), function (_a) {
        var _b = __read(_a, 2), initialTopMostItemIndex = _b[1];
        setTimeout(function () {
            u.handleNext(scrollTop, function () {
                u.publish(scrolledToInitialItem, true);
            });
            u.publish(scrollToIndex, initialTopMostItemIndex);
        });
    });
    return {
        scrolledToInitialItem: scrolledToInitialItem,
        initialTopMostItemIndex: initialTopMostItemIndex,
    };
}, u.tup(sizeSystem, domIOSystem, scrollToIndexSystem, propsReadySystem), { singleton: true });
